// AS1c · Beskedet att kontot är avstängt, från /auth/me eller inloggningen till ModerationNotice.
// Egen modul utan beroenden så att api.ts kan använda den.

const SUSPENDED_KEY = 'qvenari_suspended';
export const SUSPENDED_EVENT = 'qvenari:suspended';

/** Kallas när /auth/me eller inloggningen svarat att kontot är avstängt. */
export function rememberSuspended(message: string) {
  try { sessionStorage.setItem(SUSPENDED_KEY, message); } catch { /* privat läge */ }
  window.dispatchEvent(new Event(SUSPENDED_EVENT));
}

/** Beskedet en gång (tas bort när det lästs). */
export function takeSuspended(): string | null {
  try { const m = sessionStorage.getItem(SUSPENDED_KEY); if (m) sessionStorage.removeItem(SUSPENDED_KEY); return m; } catch { return null; }
}
